export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const GENERATE_OTP_REQUEST = "GENERATE_OTP_REQUEST";
export const REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST";
export const LOGOUT = "LOGOUT";

export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const ADMIN = "ADMIN";
